import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DynamicForm from './VerificationForm';
const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };
const TaskList = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null); // State for selected task

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/client/fieldwork/getassignedfilesbyuser/${localStorage.getItem('userID')}`,
            {
                headers: {
                  'auth_key': `${getAuthKey()}`,
                }
              }
        );
        const resultData = response.data.result;

        setTasks(resultData);
      } catch (err) {
        setError('Failed to fetch tasks');
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, []);

  if (loading) {
    return <div>Loading tasks...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (selectedTask) {
    // Render DynamicForm when a task is selected
    return <DynamicForm fileId={selectedTask.fileId} />;
  }

  return (
    <div className="container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-4">Assigned Tasks</h1>
      {tasks.length === 0 ? (
        <p>No tasks assigned</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {tasks.map((task) => (
            <div key={task.taskId} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h2 className="text-xl font-semibold text-gray-800">{task.subClientName}</h2>
              <p className="text-sm text-gray-600">Assigned to: {task.fieldOfficerName}</p>
              <p className="text-sm text-gray-600">Verification Type: {task.componentName}</p>
              <p className="text-sm text-gray-600">Applicant Name: {task.customerName}</p>
              <button className="mt-4 text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-full" onClick={() =>
                  setSelectedTask({ fileId: task.fileDetailsId /* Adjust this dynamically based on task */ })
                }>View Task</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TaskList;
